module.exports = __webpack_public_path__ + "static/media/whisky_hero_desktop.9c5d5d95.jpg";